export default __webpack_public_path__ + "static/InternationalFeeSchedule-64cb4733a03cfb56b0d1bb238fac4574.pdf";